import { format, parseISO } from "date-fns";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

import { HomeFeatureCard } from "./HomeFeatureCard";
import { useMembership } from "@/lib/membership";

const actionClass =
  "min-h-44 flex-1 flex justify-between items-center gap-10 px-15 py-15 font-body text-14 leading-130 text-white bg-black hover:bg-[#1a1a1a]";

function formatDate(value: string | null): string | null {
  if (!value) return null;
  try {
    return format(parseISO(value), "MMM d, yyyy");
  } catch {
    return null;
  }
}

/** System Membership perks on Home. Renders nothing for non-members. */
export function MembershipHomeCard() {
  const { membership, percent } = useMembership();
  if (!membership) return null;
  const date = formatDate(membership.renews_at);
  const price = `$${Math.round(membership.price_cents / 100)}/yr`;
  const meta = date
    ? `${membership.cancel_at_period_end ? "Ends" : "Renews"} ${date}`
    : price;
  const perks = [
    `${percent}% off every renewal, new treatment and Shop order`,
    `At-home blood test every ${membership.lab_interval_months} months, included`,
    membership.cancel_at_period_end
      ? `Membership ends ${date ?? "at the end of your term"}`
      : `Renews at ${price}${date ? ` on ${date}` : ""}`,
  ];
  return (
    <HomeFeatureCard
      label="System Membership"
      meta={meta}
      actions={
        <>
          <Link className={actionClass} to="/app/shop">
            Shop member prices
            <ArrowRight size={16} aria-hidden />
          </Link>
          <Link
            className={`${actionClass} border-l border-white/25`}
            to="/app/labs"
          >
            Blood tests
            <ArrowRight size={16} aria-hidden />
          </Link>
        </>
      }
    >
      <div className="px-15 py-20">
        <h2 className="font-mono uppercase text-24 leading-110 text-white">
          {percent}% off everything.
        </h2>
        <ul className="mt-12 flex flex-col gap-8">
          {perks.map((perk) => (
            <li
              key={perk}
              className="font-body text-15 text-white/75 leading-140 flex gap-8"
            >
              <span aria-hidden className="text-[#CFE3D6]">
                ✓
              </span>
              {perk}
            </li>
          ))}
        </ul>
      </div>
    </HomeFeatureCard>
  );
}
